import {
  FlowStepType,
  IActivity,
  IAmenity,
  IBoondock,
  IDtoListingBooking,
  IDtoListingLocation,
  IDtoSignUpPriceStep,
  IDtoSiteAmenities,
  IDtoSiteDetails,
  IDtoSiteIsolation,
  IDtoSiteName,
  ILandType,
  IListing,
  IPhoto,
  IPolicy,
  IRV,
  ISignalReception,
  ISignUpFlowStep,
  ISite,
  IUser,
  IVehicle,
} from '@curbnturf/entities';
import { createAction, props } from '@ngrx/store';

export interface SignUpStateState {
  currentStep?: ISignUpFlowStep;
  percentComplete?: number;
  redirect?: string;
  user?: IUser;
  listing?: IListing;
  selectedSite?: ISite;
  boondock?: IBoondock;
  spinner: boolean;
  steps: ISignUpFlowStep[];
}

export enum SignUpStateActionTypes {
  SignUpInitialize = '[SignUpState] Initialize',
  SignUpSetState = '[SignUpState] Set SignUpState',
  SignUpRedirect = '[SignUpState] Redirect',
  SignUpNextStep = '[SignUpState] Next Step',
  SignUpPreviousStep = '[SignUpState] Previous Step',
  SignUpSaveState = '[SignUpState] Save State',
  SignUpUpdateInProgressListingId = '[SignUpState] Update In Progress Listing ID',
  SignUpSaveStateSuccess = '[SignUpState] Save State Success',
  SignUpSaveStateFailed = '[SignUpState] Save State Failure',
  SignUpSaveSiteState = '[SignUpState] Save Site State',
  SignUpSaveSiteStateSuccess = '[SignUpState] Save Site State Success',
  SignUpSaveSiteStateFailed = '[SignUpState] Save Site State Failure',
  SignUpSaveUserState = '[SignUpState] Save User State',
  SignUpStartGuestFlow = '[SignUpState] Begin Guest Flow',
  SignUpStartHostFlow = '[SignUpState] Begin Host Flow',
  SignUpSwitchWizardFlow = '[SignUpState] Switch Wizard Flow',
  SignUpSetCurrentStep = '[SignUpState] Set Current Step',
  SignUpSetCurrentStepType = '[SignUpState] Set Current Step Type',
  SignUpSetListingTypeHost = '[SignUp] Set Listing Type Host',
  SignUpSetListingTypeHostSuccess = '[SignUp] Set Listing Type Host Success',
  SignUpSetBoondockStepSuccess = '[SignUp] Set Boondock Step Success',
  SignUpSaveSourceStep = '[SignUp] Save Source Step',
  SignUpSavePhoneStep = '[SignUp] Save Phone Step',
  SignUpSavePropertyTypeStep = '[SignUp] Save Property Type Step',
  SignUpSetBoondockPropertyTypeStep = '[SignUp] Set Boondock Property Type Step',
  SignUpSaveAmenitiesStep = '[SignUp] Save Amenities Step',
  SignUpSaveBoondockAmenitiesStep = '[SignUp] Save Boondock Amenities Step',
  SignUpSaveActivitiesStep = '[SignUp] Save Activities Step',
  SignUpSaveBoondockActivitiesStep = '[SignUp] Save Boondock Activities Step',
  SignUpSaveIsolationStep = '[SignUp] Save Isolation Step',
  SignUpSaveBoondockLandStep = '[SignUp] Save Boondock Land Step',
  SignUpSaveBoondockIsolationStep = '[SignUp] Save Boondock Isolation Step',
  SignUpSaveVehiclesStep = '[SignUp] Save Vehicles Step',
  SignUpSaveDetailsStep = '[SignUp] Save Details Step',
  SignUpSavePriceStep = '[SignUp] Save Price Step',
  SignUpSaveBookingStep = '[SignUp] Save Booking Step',
  SignUpSaveMultiSiteStep = '[SignUp] Save Multi-Site Step',
  SignUpSavePoliciesStep = '[SignUp] Save Policies Step',
  SignUpSaveLocationStep = '[SignUp] Save Location Step',
  SignUpSaveBoondockLocationStep = '[SignUp] Save Boondock Location Step',
  SignUpStartUserTentFlow = '[SignUp] Start User Tent Flow',
  SignUpStartUserRvFlow = '[SignUp] Start User RV Flow',
  SignUpSaveUserRvStep = '[SignUp] Save User RV Step',
  SignUpSaveUserRvSizeStep = '[SignUp] Save User RV Size Step',
  SignUpSaveUserTentStep = '[SignUp] Save User Tent Step',
  SignUpSaveUserRoadConditionsStep = '[SignUp] Save User Road Conditions Step',
  SignUpSaveDescriptionStep = '[SignUp] Save Description Step',
  SignUpSaveBoondockDescriptionStep = '[SignUp] Save Boondock Description Step',
  SignUpSaveSiteNameStep = '[SignUp] Save Site Name Step',
  SignUpSaveClientProfileStep = '[SignUp] GROW - Save Client Profile Step',
  SignUpSaveClientProfileStepSuccess = '[SignUp] GROW - Save Client Profile Step Success',
  SignUpSaveClientProfileStepFailed = '[SignUp] GROW - Save Client Profile Step Failed',
  SignUpUpdateProfilePhoto = '[SignUp] Update Profile Photo',
  SignUpUploadProfileImage = '[SignUp] Upload Profile Photo',
  SignUpListingPhotos = '[SignUp] Update Listing Photos',
  SignUpBoondockPhotos = '[SignUp] Update Boondock Photos',
  SignUpSavePhotosStep = '[SignUp] Save Photos Step',
  SignUpSaveBoondockPhotosStep = '[SignUp] Save Boondock Photos Step',
  ListingSalesComplete = '[SignUp] Sales Complete Listing',
  SignUpPublishListing = '[SignUp] Publish Listing',
  SignUpPublishBoondock = '[SignUp] Publish Boondock',
  SignUpPublishListingFailed = '[SignUp] Publish Listing Failed',
  SignUpPublishBoondockFailed = '[SignUp] Publish Boondock Failed',
  SignUpPublishLater = '[SignUp] Publish Later',
  SignUpBoondockPublishLater = '[SignUp] Boondock Publish Later',
  SignUpPublishLaterFailed = '[SignUp] Publish Later Failed',
  SignUpBoondockPublishLaterFailed = '[SignUp] Boondock Publish Later Failed',
  SignUpRestoreListing = '[SignUp] Restore Listing From Server',
  SignUpRestoreListingSuccess = '[SignUp] Restore Listing From Server Success',
  SignUpRestoreListingFailed = '[SignUp] Restore Listing From Server Failed',
  SignUpRestoreUser = '[SignUp] Restore User From Server',
  SignUpRestoreUserSuccess = '[SignUp] Restore User From Server Success',
  SignUpRestoreUserFailed = '[SignUp] Restore User From Server Failed',
  SignUpResetProcess = '[SignUp] Reset Sign Up Process',
  SignUpSetInProgressListing = '[SignUp] Set In Progress Listing',
  SignUpClearInProgressListing = '[SignUp] Clear In Progress Listing',
  SignUpClearInProgressListingSuccess = '[SignUp] Clear In Progress Listing Success',
  SignUpDisplaySpinner = '[SignUp] Display Spinner',
  SignUpHideSpinner = '[SignUp] Hide Spinner',
  SignUpStartNewListingAndFlow = '[SignUp] Start New Listing and Flow',
  SignUpStartNewListing = '[SignUp] Start New Listing',
  SignUpStartNewListingSuccess = '[SignUp] Start New Listing Success',
  SignUpStartNewListingFailed = '[SignUp] Start New Listing Failed',
  SignUpStartNewBoondock = '[SignUp] Start New Boondock',
  SignUpStartNewBoondockSuccess = '[SignUp] Start New Boondock Success',
  SignUpStartNewBoondockFailed = '[SignUp] Start New Boondock Failed',
  SignUpRegisterForNewsletter = '[SignUp] Register For Newsletter',
  SignUpSelectSiteFromListing = '[SignUp] Select Site From Listing',
  SignUpEditSelectedSite = '[SignUp] Edit Selected Site',
  SignUpGoToStep = '[SignUp] Go To Step',
  SignUpEnableSite = '[SignUp] Enable Site',
  SignUpEnableSiteSuccess = '[SignUp] Enable Site Success',
  SignUpDisableSite = '[SignUp] Disable Site',
  SignUpDisableSiteSuccess = '[SignUp] Disable Site Success',
  SignUpRemoveSite = '[SignUp] Remove Site',
  SignUpDuplicateSite = '[SignUp] Duplicate Site',
  SignUpDuplicateSiteSuccess = '[SignUp] Duplicate Site Success',
  SignUpDuplicateSiteError = '[SignUp] Duplicate Site Error',
  SignUpAddNewSite = '[SignUp] Add New Site',
  SignUpAddNewSiteSuccess = '[SignUp] Add New Site Success',
  SignUpAddNewSiteError = '[SignUp] Add New Site Error',
  SignUpSaveSitePhotos = '[SignUp] Save Site Photos Step',
  SiteUpdatePhotoDetails = '[SignUp] Site Update Photo Details',
  ListingUpdatePhotoDetails = '[SignUp] Listing Update Photo Details',
  BoondockUpdatePhotoDetails = '[SignUp] Boondock Update Photo Details',
  SendOwnerEmail = '[SignUp] Send Owner Email',
  SendOwnerEmailSuccess = '[SignUp] Send Owner Email Success',
  SendOwnerEmailFailed = '[SignUp] Send Owner Email Failed',
}

export const init = createAction(SignUpStateActionTypes.SignUpInitialize);

export const setState = createAction(SignUpStateActionTypes.SignUpSetState, props<SignUpStateState>());

// @todo Do we really need this action?
export const redirect = createAction(SignUpStateActionTypes.SignUpRedirect, props<{ routeTo: string }>());

export const nextStep = createAction(SignUpStateActionTypes.SignUpNextStep, props<{ override?: string }>());

export const previousStep = createAction(SignUpStateActionTypes.SignUpPreviousStep, props<{ override?: string }>());

export const saveState = createAction(SignUpStateActionTypes.SignUpSaveState, props<{ redirect?: ISignUpFlowStep }>());

export const saveStateSuccess = createAction(
  SignUpStateActionTypes.SignUpSaveStateSuccess,
  props<{ user?: IUser; listing?: IListing; boondock?: IBoondock }>(),
);

export const saveStateFailed = createAction(SignUpStateActionTypes.SignUpSaveStateFailed, props<{ error: any }>());

export const saveSiteState = createAction(
  SignUpStateActionTypes.SignUpSaveSiteState,
  props<{ redirect?: ISignUpFlowStep }>(),
);

export const saveSiteStateSuccess = createAction(
  SignUpStateActionTypes.SignUpSaveSiteStateSuccess,
  props<{ site?: ISite }>(),
);

export const saveSiteStateFailed = createAction(
  SignUpStateActionTypes.SignUpSaveSiteStateFailed,
  props<{ error: any }>(),
);

export const saveUserState = createAction(SignUpStateActionTypes.SignUpSaveUserState, props<{ user: IUser }>());

export const updateInProgressListingId = createAction(SignUpStateActionTypes.SignUpUpdateInProgressListingId);

export const startGuestFlow = createAction(SignUpStateActionTypes.SignUpStartGuestFlow, props<{ user: IUser }>());

export const startHostFlow = createAction(SignUpStateActionTypes.SignUpStartHostFlow, props<{ user?: IUser }>());

export const switchWizardFlow = createAction(
  SignUpStateActionTypes.SignUpSwitchWizardFlow,
  props<{ flow: ISignUpFlowStep[] }>(),
);

export const setCurrentStep = createAction(
  SignUpStateActionTypes.SignUpSetCurrentStep,
  props<{ step: ISignUpFlowStep }>(),
);

export const setCurrentStepType = createAction(
  SignUpStateActionTypes.SignUpSetCurrentStepType,
  props<{ step: FlowStepType }>(),
);

export const setListingTypeHost = createAction(
  SignUpStateActionTypes.SignUpSetListingTypeHost,
  props<{ listing?: IListing }>(),
);

export const setListingTypeHostSuccess = createAction(
  SignUpStateActionTypes.SignUpSetListingTypeHostSuccess,
  props<{ listing?: IListing; user?: IUser }>(),
);

export const setBoondockStepSuccess = createAction(
  SignUpStateActionTypes.SignUpSetBoondockStepSuccess,
  props<{ boondock?: IBoondock; user?: IUser }>(),
);

export const saveSourceStep = createAction(SignUpStateActionTypes.SignUpSaveSourceStep, props<{ user: IUser }>());

export const savePhoneStep = createAction(
  SignUpStateActionTypes.SignUpSavePhoneStep,
  props<{ user: IUser; assistance: boolean }>(),
);

export const savePropertyTypeStep = createAction(
  SignUpStateActionTypes.SignUpSavePropertyTypeStep,
  props<{ types: ILandType['type'][] }>(),
);

export const setBoondockPropertyTypeStep = createAction(
  SignUpStateActionTypes.SignUpSetBoondockPropertyTypeStep,
  props<{ landTypes: ILandType['type'][] }>(),
);

export const saveAmenitiesStep = createAction(
  SignUpStateActionTypes.SignUpSaveAmenitiesStep,
  props<IDtoSiteAmenities>(),
);

export const saveBoondockAmenitiesStep = createAction(
  SignUpStateActionTypes.SignUpSaveBoondockAmenitiesStep,
  props<{ amenities: IAmenity[]; signalReception: ISignalReception[] }>(),
);

export const saveActivitiesStep = createAction(
  SignUpStateActionTypes.SignUpSaveActivitiesStep,
  props<{ activities: IActivity[] }>(),
);

export const saveBoondockActivitiesStep = createAction(
  SignUpStateActionTypes.SignUpSaveBoondockActivitiesStep,
  props<{ activities: IActivity[] }>(),
);

export const saveIsolationStep = createAction(
  SignUpStateActionTypes.SignUpSaveIsolationStep,
  props<IDtoSiteIsolation>(),
);

export const saveBoondockLandStep = createAction(
  SignUpStateActionTypes.SignUpSaveBoondockLandStep,
  props<{ boondock: IBoondock }>(),
);

export const saveBoondockIsolationStep = createAction(
  SignUpStateActionTypes.SignUpSaveBoondockIsolationStep,
  props<IDtoSiteIsolation>(),
);

export const saveVehiclesStep = createAction(SignUpStateActionTypes.SignUpSaveVehiclesStep, props<IVehicle>());

export const saveDetailsStep = createAction(SignUpStateActionTypes.SignUpSaveDetailsStep, props<IDtoSiteDetails>());

export const savePriceStep = createAction(SignUpStateActionTypes.SignUpSavePriceStep, props<IDtoSignUpPriceStep>());

export const saveBookingStep = createAction(SignUpStateActionTypes.SignUpSaveBookingStep, props<IDtoListingBooking>());
export const saveMultiSiteStep = createAction(
  SignUpStateActionTypes.SignUpSaveMultiSiteStep,
  props<{ multisite: 'multi' | 'sales' }>(),
);

export const savePoliciesStep = createAction(
  SignUpStateActionTypes.SignUpSavePoliciesStep,
  props<{ policies: IPolicy[] }>(),
);

export const saveLocationStep = createAction(
  SignUpStateActionTypes.SignUpSaveLocationStep,
  props<IDtoListingLocation>(),
);

export const saveBoondockLocationStep = createAction(
  SignUpStateActionTypes.SignUpSaveBoondockLocationStep,
  props<IDtoListingLocation>(),
);

export const startUserTentFlow = createAction(SignUpStateActionTypes.SignUpStartUserTentFlow);

export const startUserRvFlow = createAction(SignUpStateActionTypes.SignUpStartUserRvFlow);

export const saveUserRvStep = createAction(SignUpStateActionTypes.SignUpSaveUserRvStep, props<{ rv: IRV }>());

export const saveUserRvSizeStep = createAction(SignUpStateActionTypes.SignUpSaveUserRvSizeStep, props<{ rv: IRV }>());

export const saveUserTentStep = createAction(SignUpStateActionTypes.SignUpSaveUserTentStep, props<{ rv: IRV }>());

export const saveUserRoadConditionStep = createAction(
  SignUpStateActionTypes.SignUpSaveUserRoadConditionsStep,
  props<{ rv: IRV }>(),
);

export const saveDescriptionStep = createAction(
  SignUpStateActionTypes.SignUpSaveDescriptionStep,
  props<IDtoSiteName>(),
);

export const saveBoondockDescriptionStep = createAction(
  SignUpStateActionTypes.SignUpSaveBoondockDescriptionStep,
  props<IDtoSiteName>(),
);

export const saveSiteNameStep = createAction(SignUpStateActionTypes.SignUpSaveSiteNameStep, props<IDtoSiteName>());

export const saveClientProfileStep = createAction(
  SignUpStateActionTypes.SignUpSaveClientProfileStep,
  props<{ user: IUser; newsletter: boolean | null | undefined }>(),
);

export const saveClientProfileStepSuccess = createAction(
  SignUpStateActionTypes.SignUpSaveClientProfileStepSuccess,
  props<{ user: IUser }>(),
);

export const saveClientProfileStepFailed = createAction(
  SignUpStateActionTypes.SignUpSaveClientProfileStepFailed,
  props<{ error: any }>(),
);

export const updateProfilePhoto = createAction(
  SignUpStateActionTypes.SignUpUpdateProfilePhoto,
  props<{ photo: IPhoto }>(),
);

export const updateListingPhotos = createAction(
  SignUpStateActionTypes.SignUpListingPhotos,
  props<{ photos: IPhoto[]; listingId?: number }>(),
);

export const savePhotosStep = createAction(SignUpStateActionTypes.SignUpSavePhotosStep, props<{ photos: IPhoto[] }>());

export const saveBoondockPhotosStep = createAction(
  SignUpStateActionTypes.SignUpSaveBoondockPhotosStep,
  props<{ photos: IPhoto[] }>(),
);

export const publishListing = createAction(SignUpStateActionTypes.SignUpPublishListing);
export const publishBoondock = createAction(SignUpStateActionTypes.SignUpPublishBoondock);

export const publishListingFailed = createAction(
  SignUpStateActionTypes.SignUpPublishListingFailed,
  props<{ error: any }>(),
);

export const publishBoondockFailed = createAction(
  SignUpStateActionTypes.SignUpPublishBoondockFailed,
  props<{ error: any }>(),
);

export const publishLater = createAction(SignUpStateActionTypes.SignUpPublishLater);

export const boondockPublishLater = createAction(SignUpStateActionTypes.SignUpBoondockPublishLater);

export const publishLaterFailed = createAction(
  SignUpStateActionTypes.SignUpPublishLaterFailed,
  props<{ error: any }>(),
);

export const boondockPublishLaterFailed = createAction(
  SignUpStateActionTypes.SignUpBoondockPublishLaterFailed,
  props<{ error: any }>(),
);

export const restoreListing = createAction(
  SignUpStateActionTypes.SignUpRestoreListing,
  props<{ listingId?: number }>(),
);

export const restoreListingSuccess = createAction(
  SignUpStateActionTypes.SignUpRestoreListingSuccess,
  props<{ listing: IListing; currentUser?: IUser }>(),
);

export const restoreListingFailed = createAction(
  SignUpStateActionTypes.SignUpRestoreListingFailed,
  props<{ error: any }>(),
);

export const restoreUser = createAction(SignUpStateActionTypes.SignUpRestoreUser);

export const restoreUserSuccess = createAction(
  SignUpStateActionTypes.SignUpRestoreUserSuccess,
  props<{ user: IUser; currentUser?: IUser }>(),
);

export const restoreUserFailed = createAction(SignUpStateActionTypes.SignUpRestoreUserFailed, props<{ error: any }>());

export const resetProcess = createAction(SignUpStateActionTypes.SignUpResetProcess);

export const setInProgressListing = createAction(
  SignUpStateActionTypes.SignUpSetInProgressListing,
  props<{ listing: IListing }>(),
);

export const clearInProgressListing = createAction(SignUpStateActionTypes.SignUpClearInProgressListing);

export const clearInProgressListingSuccess = createAction(SignUpStateActionTypes.SignUpClearInProgressListingSuccess);

export const displaySpinner = createAction(SignUpStateActionTypes.SignUpDisplaySpinner);

export const hideSpinner = createAction(SignUpStateActionTypes.SignUpHideSpinner);

export const startNewListingAndFlow = createAction(
  SignUpStateActionTypes.SignUpStartNewListingAndFlow,
  props<{ user?: IUser; currentUser?: IUser }>(),
);

export const startNewListing = createAction(
  SignUpStateActionTypes.SignUpStartNewListing,
  props<{ user?: IUser; currentUser?: IUser }>(),
);

export const startNewListingSuccess = createAction(
  SignUpStateActionTypes.SignUpStartNewListingSuccess,
  props<{ listing: IListing; user: IUser }>(),
);

export const startNewListingFailed = createAction(
  SignUpStateActionTypes.SignUpStartNewListingFailed,
  props<{ error: any }>(),
);

export const startNewBoondock = createAction(
  SignUpStateActionTypes.SignUpStartNewBoondock,
  props<{ user?: IUser; currentUser?: IUser }>(),
);

export const startNewBoondockSuccess = createAction(
  SignUpStateActionTypes.SignUpStartNewBoondockSuccess,
  props<{ boondock: IBoondock; user: IUser }>(),
);

export const startNewBoondockFailed = createAction(
  SignUpStateActionTypes.SignUpStartNewBoondockFailed,
  props<{ error: any }>(),
);

export const listingSalesComplete = createAction(
  SignUpStateActionTypes.ListingSalesComplete,
  props<{ listingId: number }>(),
);

export const uploadUserProfileImage = createAction(
  SignUpStateActionTypes.SignUpUploadProfileImage,
  props<{ formData: FormData; data?: { id?: number } }>(),
);

export const registerForNewsletter = createAction(
  SignUpStateActionTypes.SignUpRegisterForNewsletter,
  props<{ user: IUser }>(),
);

export const selectSiteFromListing = createAction(
  SignUpStateActionTypes.SignUpSelectSiteFromListing,
  props<{ site: ISite }>(),
);

export const editSelectedSite = createAction(
  SignUpStateActionTypes.SignUpEditSelectedSite,
  props<{ selectedSite: ISite }>(),
);

export const goToStep = createAction(SignUpStateActionTypes.SignUpGoToStep, props<{ step: FlowStepType }>());

export const enableSite = createAction(SignUpStateActionTypes.SignUpEnableSite, props<{ site: ISite }>());

export const enableSiteSuccess = createAction(SignUpStateActionTypes.SignUpEnableSiteSuccess, props<{ site: ISite }>());

export const disableSite = createAction(SignUpStateActionTypes.SignUpDisableSite, props<{ site: ISite }>());

export const disableSiteSuccess = createAction(
  SignUpStateActionTypes.SignUpDisableSiteSuccess,
  props<{ site: ISite }>(),
);

export const removeSite = createAction(SignUpStateActionTypes.SignUpRemoveSite, props<{ site: ISite }>());

export const duplicateSite = createAction(
  SignUpStateActionTypes.SignUpDuplicateSite,
  props<{ site: ISite; name: string }>(),
);

export const duplicateSiteSuccess = createAction(
  SignUpStateActionTypes.SignUpDuplicateSiteSuccess,
  props<{ site: ISite }>(),
);

export const duplicateSiteError = createAction(SignUpStateActionTypes.SignUpDuplicateSiteError, props<{ err: any }>());

export const addNewSite = createAction(SignUpStateActionTypes.SignUpAddNewSite);

export const addNewSiteSuccess = createAction(
  SignUpStateActionTypes.SignUpAddNewSiteSuccess,
  props<{ listing: IListing }>(),
);

export const addNewSiteError = createAction(SignUpStateActionTypes.SignUpAddNewSiteError, props<{ err: any }>());

export const saveSitePhotosStep = createAction(
  SignUpStateActionTypes.SignUpSaveSitePhotos,
  props<{ photos: IPhoto[] }>(),
);

export const updateSitePhotoDetails = createAction(
  SignUpStateActionTypes.SiteUpdatePhotoDetails,
  props<{ siteId: number; photos: IPhoto[]; continueWizard?: boolean }>(),
);

export const updateListingPhotoDetails = createAction(
  SignUpStateActionTypes.ListingUpdatePhotoDetails,
  props<{ listingId: number; photos: IPhoto[]; continueWizard?: boolean }>(),
);

export const updateBoondockPhotos = createAction(
  SignUpStateActionTypes.SignUpBoondockPhotos,
  props<{ photos: IPhoto[]; boondockId?: number }>(),
);

export const updateBoondockPhotoDetails = createAction(
  SignUpStateActionTypes.BoondockUpdatePhotoDetails,
  props<{ boondockId: number; photos: IPhoto[]; continueWizard?: boolean }>(),
);

export const sendOwnerEmail = createAction(SignUpStateActionTypes.SendOwnerEmail);

export const sendOwnerEmailSuccess = createAction(
  SignUpStateActionTypes.SendOwnerEmailSuccess,
  props<{ user: IUser }>(),
);

export const sendOwnerEmailFailed = createAction(SignUpStateActionTypes.SendOwnerEmailFailed, props<{ err: any }>());
